module.exports = __webpack_public_path__ + "img/plus.125afee4.svg";